import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { readImageFiles } from '../../../utils/fileDropBrowserUtils';
import { getFiles, SUPPORTED_IMAGE_MIMETYPES } from '../../../utils/fileDropUtils';
import { Button } from '../../_atoms/Button';
import FileDropComponent from '../../_atoms/FileDropComponent/FileDropComponent';
import MaxSizeMediaContent from '../MaxSizeMediaContent';

const CoverPhotoEditor = ({
  onUpload,
  isUploading,
}: {
  onUpload: (data: { src: string; mimeType: string }) => void;
  isUploading: boolean;
}) => {
  const hiddenFileInputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File>();
  const [imageData, setImageData] = useState<{ src: string; mimeType: string }>();
  const { t } = useTranslation('Host');
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files && files[0]) {
      const file = files.item(0);
      if (file) {
        setFile(file);
      }
    }
  };

  const handleActivate = () => {
    if (hiddenFileInputRef.current) {
      hiddenFileInputRef.current.value = '';
      hiddenFileInputRef.current!.click();
    }
  };

  const handleFilesDropped = (files: FileList | null) => {
    if (files) {
      const parsedFiles = getFiles(files);
      const invalidFiles = parsedFiles.filter(
        file => !SUPPORTED_IMAGE_MIMETYPES.includes(file.type),
      );
      if (invalidFiles.length > 0) {
        alert(t('Invalid file type, please try again'));
        return;
      }

      if (parsedFiles.length > 0) {
        setFile(parsedFiles[0]);
      }
    }
  };

  const handleUpload = () => {
    if (imageData) {
      onUpload({ src: imageData.src, mimeType: imageData.mimeType });
    }
  };

  useEffect(() => {
    if (file) {
      readImageFiles(file)
        .then(setImageData)
        .catch(e => {
          // eslint-disable-next-line no-console
          console.error(e);
        });
    }
  }, [file]);

  if (imageData) {
    return (
      <div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ height: 200, width: 320 }}>
            <MaxSizeMediaContent>
              <img
                src={imageData.src}
                alt=""
                style={{ height: '100%', width: '100%', objectFit: 'contain' }}
              />
            </MaxSizeMediaContent>
          </div>
        </div>
        <Button loading={isUploading} onClick={handleUpload}>
          {t('Upload')}
        </Button>
      </div>
    );
  }

  return (
    <FileDropComponentContainer>
      <input
        ref={hiddenFileInputRef}
        type="file"
        name="myFile"
        multiple={false}
        accept={SUPPORTED_IMAGE_MIMETYPES.join(',')}
        onChange={onChange}
        style={{ display: 'none' }}
      />
      <FileDropComponent onClick={handleActivate} onFilesDropped={handleFilesDropped} />
    </FileDropComponentContainer>
  );
};

export default CoverPhotoEditor;

const FileDropComponentContainer = styled.div`
  width: 100%;
  flex: 1 1 100%;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;
